declare const DEPLOYMENT_ENVIRONMENT: string;

export const PRODUCTION_DEPLOYMENT_ENVIRONMENT = 'production';
export const STAGING_DEPLOYMENT_ENVIRONMENT = 'staging';
const LOCAL_DEVELOPMENT_DEPLOYMENT_ENVIRONMENTS = new Set(['development', 'dev', 'local', 'test']);

// Keep deployment gating explicit here rather than inferring it from payload shape or hostnames.
export const getDeploymentEnvironment = (): string | null => {
  if (typeof DEPLOYMENT_ENVIRONMENT === 'undefined') {
    return null;
  }

  return DEPLOYMENT_ENVIRONMENT;
};

export const getNonProductionEnvironmentLabelForEnvironment = (deploymentEnvironment: string | null): string | null => {
  if (!deploymentEnvironment) {
    return null;
  }

  const normalizedDeploymentEnvironment = deploymentEnvironment.toLowerCase();

  if (normalizedDeploymentEnvironment === PRODUCTION_DEPLOYMENT_ENVIRONMENT) {
    return null;
  }

  return normalizedDeploymentEnvironment;
};

export const getLocalDevelopmentEnvironmentLabelForEnvironment = (
  deploymentEnvironment: string | null
): string | null => {
  if (!deploymentEnvironment) {
    return null;
  }

  const normalizedDeploymentEnvironment = deploymentEnvironment.toLowerCase();

  if (!LOCAL_DEVELOPMENT_DEPLOYMENT_ENVIRONMENTS.has(normalizedDeploymentEnvironment)) {
    return null;
  }

  return normalizedDeploymentEnvironment;
};

export const getLocalDevelopmentEnvironmentLabel = (): string | null => {
  return getLocalDevelopmentEnvironmentLabelForEnvironment(getDeploymentEnvironment());
};

export const getNonProductionEnvironmentLabel = (): string | null => {
  return getNonProductionEnvironmentLabelForEnvironment(getDeploymentEnvironment());
};

export const isNonProductionEnvironment = (): boolean => {
  return getNonProductionEnvironmentLabel() !== null;
};

export const formatApplicationTitle = (baseTitle: string, deploymentEnvironment: string | null): string => {
  const nonProductionEnvironmentLabel = getNonProductionEnvironmentLabelForEnvironment(deploymentEnvironment);

  if (!nonProductionEnvironmentLabel) {
    return baseTitle;
  }

  return `${baseTitle} (${nonProductionEnvironmentLabel})`;
};

export const getApplicationTitle = (baseTitle: string): string => {
  const localDevelopmentEnvironmentLabel = getLocalDevelopmentEnvironmentLabelForEnvironment(
    getDeploymentEnvironment()
  );

  if (!localDevelopmentEnvironmentLabel) {
    return baseTitle;
  }

  return `${baseTitle} (${localDevelopmentEnvironmentLabel})`;
};
